export default "b419b8ae01273bad.svg"